import React, {  useEffect, useMemo, useRef, useState } from "react";

import { Button } from "primereact/button";

import { useQuery } from "@tanstack/react-query";
import accessManagementService from "../../services/accessManagementService";
import TableComponent from "../../component/Tables/tableComponent";
import { Menu } from "primereact/menu";
import {  confirmDialog } from "primereact/confirmdialog";

import ChangeMemberRoleDialog from "./ChangeMemberRoleDialog.js";
import { ChangeUserRoleMutation } from "../../mutations/AccessManagementMutationHook.js";

import { useToast } from "../../context/ToastContext.js";
import { multiSelectFilter } from "./RuleElevationPage.js";



let dummyData=[
    {
        "asset_name": "asset_001",
        "domain": "MasterData",
        "sub_domain": "Finance",
        "region": "Developed APAC",
        "country": "South LATAM",
        "last_updated": "2024-01-10",
        "status": "Success"
    },
    {
        "asset_name": "asset_002",
        "domain": "CustomerData",
        "sub_domain": "Marketing",
        "region": "Emerging EMEA",
        "country": "North America",
        "last_updated": "2024-02-15",
        "status": "Failed"
    },
    {
        "asset_name": "asset_003",
        "domain": "ProductData",
        "sub_domain": "Sales",
        "region": "Developed Europe",
        "country": "Developed APAC",
        "last_updated": "2024-03-22",
        "status": "Pending"
    },
    {
        "asset_name": "asset_004",
        "domain": "MasterData",
        "sub_domain": "Operations",
        "region": "North America",
        "country": "Emerging EMEA",
        "last_updated": "2024-04-01",
        "status": "Success"
    },
    {
        "asset_name": "asset_005",
        "domain": "Finance",
        "sub_domain": "Reporting",
        "region": "South LATAM",
        "country": "Developed Europe",
        "last_updated": "2024-05-08",
        "status": "Failed"
    },
    {
        "asset_name": "asset_006",
        "domain": "CustomerData",
        "sub_domain": "Finance",
        "region": "Developed APAC",
        "country": "South LATAM",
        "last_updated": "2024-06-19",
        "status": "Success"
    },
    {
        "asset_name": "asset_007",
        "domain": "MasterData",
        "sub_domain": "Marketing",
        "region": "Emerging EMEA",
        "country": "North America",
        "last_updated": "2024-07-03",
        "status": "Pending"
    },
    {
        "asset_name": "asset_008",
        "domain": "ProductData",
        "sub_domain": "Sales",
        "region": "Developed Europe",
        "country": "Developed APAC",
        "last_updated": "2024-08-11",
        "status": "Success"
    },
    {
        "asset_name": "asset_009",
        "domain": "Finance",
        "sub_domain": "Operations",
        "region": "North America",
        "country": "Emerging EMEA",
        "last_updated": "2024-09-25",
        "status": "Failed"
    },
    {
        "asset_name": "asset_010",
        "domain": "MasterData",
        "sub_domain": "Reporting",
        "region": "South LATAM",
        "country": "Developed Europe",
        "last_updated": "2024-10-17",
        "status": "Pending"
    },
    {
        "asset_name": "asset_011",
        "domain": "CustomerData",
        "sub_domain": "Finance",
        "region": "Developed APAC",
        "country": "South LATAM",
        "last_updated": "2024-11-05",
        "status": "Success"
    },
    {
        "asset_name": "asset_012",
        "domain": "ProductData",
        "sub_domain": "Marketing",
        "region": "Emerging EMEA",
        "country": "North America",
        "last_updated": "2024-12-14",
        "status": "Failed"
    },
    {
        "asset_name": "asset_013",
        "domain": "MasterData",
        "sub_domain": "Sales",
        "region": "Developed Europe",
        "country": "Developed APAC",
        "last_updated": "2025-01-20",
        "status": "Pending"
    },
    {
        "asset_name": "asset_014",
        "domain": "Finance",
        "sub_domain": "Operations",
        "region": "North America",
        "country": "Emerging EMEA",
        "last_updated": "2025-02-07",
        "status": "Success"
    },
    {
        "asset_name": "asset_015",
        "domain": "CustomerData",
        "sub_domain": "Reporting",
        "region": "South LATAM",
        "country": "Developed Europe",
        "last_updated": "2025-03-15",
        "status": "Failed"
    },
    {
        "asset_name": "asset_016",
        "domain": "MasterData",
        "sub_domain": "Finance",
        "region": "Developed APAC",
        "country": "South LATAM",
        "last_updated": "2025-04-02",
        "status": "Pending"
    },
    {
        "asset_name": "asset_017",
        "domain": "ProductData",
        "sub_domain": "Marketing",
        "region": "Emerging EMEA",
        "country": "North America",
        "last_updated": "2025-05-14",
        "status": "Success"
    },
    {
        "asset_name": "asset_018",
        "domain": "Finance",
        "sub_domain": "Sales",
        "region": "Developed Europe",
        "country": "Developed APAC",
        "last_updated": "2025-05-13",
        "status": "Failed"
    },
    {
        "asset_name": "asset_019",
        "domain": "CustomerData",
        "sub_domain": "Operations",
        "region": "North America",
        "country": "Emerging EMEA",
        "last_updated": "2025-05-12",
        "status": "Pending"
    },
    {
        "asset_name": "asset_020",
        "domain": "MasterData",
        "sub_domain": "Reporting",
        "region": "South LATAM",
        "country": "Developed Europe",
        "last_updated": "2025-05-11",
        "status": "Success"
    },
    {
        "asset_name": "asset_021",
        "domain": "ProductData",
        "sub_domain": "Finance",
        "region": "Developed APAC",
        "country": "South LATAM",
        "last_updated": "2025-05-10",
        "status": "Failed"
    },
    {
        "asset_name": "asset_022",
        "domain": "Finance",
        "sub_domain": "Marketing",
        "region": "Emerging EMEA",
        "country": "North America",
        "last_updated": "2025-05-09",
        "status": "Pending"
    },
    {
        "asset_name": "asset_023",
        "domain": "CustomerData",
        "sub_domain": "Sales",
        "region": "Developed Europe",
        "country": "Developed APAC",
        "last_updated": "2025-05-08",
        "status": "Success"
    },
    {
        "asset_name": "asset_024",
        "domain": "MasterData",
        "sub_domain": "Operations",
        "region": "North America",
        "country": "Emerging EMEA",
        "last_updated": "2025-05-07",
        "status": "Failed"
    },
    {
        "asset_name": "asset_025",
        "domain": "ProductData",
        "sub_domain": "Reporting",
        "region": "South LATAM",
        "country": "Developed Europe",
        "last_updated": "2025-05-06",
        "status": "Pending"
    },
    {
        "asset_name": "asset_026",
        "domain": "Finance",
        "sub_domain": "Finance",
        "region": "Developed APAC",
        "country": "South LATAM",
        "last_updated": "2025-05-05",
        "status": "Success"
    },
    {
        "asset_name": "asset_027",
        "domain": "CustomerData",
        "sub_domain": "Marketing",
        "region": "Emerging EMEA",
        "country": "North America",
        "last_updated": "2025-05-04",
        "status": "Failed"
    },
    {
        "asset_name": "asset_028",
        "domain": "MasterData",
        "sub_domain": "Sales",
        "region": "Developed Europe",
        "country": "Developed APAC",
        "last_updated": "2025-05-03",
        "status": "Pending"
    },
    {
        "asset_name": "asset_029",
        "domain": "ProductData",
        "sub_domain": "Operations",
        "region": "North America",
        "country": "Emerging EMEA",
        "last_updated": "2025-05-02",
        "status": "Success"
    },
    {
        "asset_name": "asset_030",
        "domain": "Finance",
        "sub_domain": "Reporting",
        "region": "South LATAM",
        "country": "Developed Europe",
        "last_updated": "2025-05-01",
        "status": "Failed"
    },
    {
        "asset_name": "asset_031",
        "domain": "CustomerData",
        "sub_domain": "Finance",
        "region": "Developed APAC",
        "country": "South LATAM",
        "last_updated": "2025-04-30",
        "status": "Pending"
    },
    {
        "asset_name": "asset_032",
        "domain": "MasterData",
        "sub_domain": "Marketing",
        "region": "Emerging EMEA",
        "country": "North America",
        "last_updated": "2025-04-29",
        "status": "Success"
    },
    {
        "asset_name": "asset_033",
        "domain": "ProductData",
        "sub_domain": "Sales",
        "region": "Developed Europe",
        "country": "Developed APAC",
        "last_updated": "2025-04-28",
        "status": "Failed"
    },
    {
        "asset_name": "asset_034",
        "domain": "Finance",
        "sub_domain": "Operations",
        "region": "North America",
        "country": "Emerging EMEA",
        "last_updated": "2025-04-27",
        "status": "Pending"
    },
    {
        "asset_name": "asset_035",
        "domain": "CustomerData",
        "sub_domain": "Reporting",
        "region": "South LATAM",
        "country": "Developed Europe",
        "last_updated": "2025-04-26",
        "status": "Success"
    },
    {
        "asset_name": "asset_036",
        "domain": "MasterData",
        "sub_domain": "Finance",
        "region": "Developed APAC",
        "country": "South LATAM",
        "last_updated": "2025-04-25",
        "status": "Failed"
    },
    {
        "asset_name": "asset_037",
        "domain": "ProductData",
        "sub_domain": "Marketing",
        "region": "Emerging EMEA",
        "country": "North America",
        "last_updated": "2025-04-24",
        "status": "Pending"
    },
    {
        "asset_name": "asset_038",
        "domain": "Finance",
        "sub_domain": "Sales",
        "region": "Developed Europe",
        "country": "Developed APAC",
        "last_updated": "2025-04-23",
        "status": "Success"
    },
    {
        "asset_name": "asset_039",
        "domain": "CustomerData",
        "sub_domain": "Operations",
        "region": "North America",
        "country": "Emerging EMEA",
        "last_updated": "2025-04-22",
        "status": "Failed"
    },
    {
        "asset_name": "asset_040",
        "domain": "MasterData",
        "sub_domain": "Reporting",
        "region": "South LATAM",
        "country": "Developed Europe",
        "last_updated": "2025-04-21",
        "status": "Pending"
    },
    {
        "asset_name": "asset_041",
        "domain": "ProductData",
        "sub_domain": "Finance",
        "region": "Developed APAC",
        "country": "South LATAM",
        "last_updated": "2025-04-20",
        "status": "Success"
    },
    {
        "asset_name": "asset_042",
        "domain": "Finance",
        "sub_domain": "Marketing",
        "region": "Emerging EMEA",
        "country": "North America",
        "last_updated": "2025-04-19",
        "status": "Failed"
    },
    {
        "asset_name": "asset_043",
        "domain": "CustomerData",
        "sub_domain": "Sales",
        "region": "Developed Europe",
        "country": "Developed APAC",
        "last_updated": "2025-04-18",
        "status": "Pending"
    },
    {
        "asset_name": "asset_044",
        "domain": "MasterData",
        "sub_domain": "Operations",
        "region": "North America",
        "country": "Emerging EMEA",
        "last_updated": "2025-04-17",
        "status": "Success"
    },
    {
        "asset_name": "asset_045",
        "domain": "ProductData",
        "sub_domain": "Reporting",
        "region": "South LATAM",
        "country": "Developed Europe",
        "last_updated": "2025-04-16",
        "status": "Failed"
    },
    {
        "asset_name": "asset_046",
        "domain": "Finance",
        "sub_domain": "Finance",
        "region": "Developed APAC",
        "country": "South LATAM",
        "last_updated": "2025-04-15",
        "status": "Pending"
    },
    {
        "asset_name": "asset_047",
        "domain": "CustomerData",
        "sub_domain": "Marketing",
        "region": "Emerging EMEA",
        "country": "North America",
        "last_updated": "2025-04-14",
        "status": "Success"
    },
    {
        "asset_name": "asset_048",
        "domain": "MasterData",
        "sub_domain": "Sales",
        "region": "Developed Europe",
        "country": "Developed APAC",
        "last_updated": "2025-04-13",
        "status": "Failed"
    },
    {
        "asset_name": "asset_049",
        "domain": "ProductData",
        "sub_domain": "Operations",
        "region": "North America",
        "country": "Emerging EMEA",
        "last_updated": "2025-04-12",
        "status": "Pending"
    },
    {
        "asset_name": "asset_050",
        "domain": "Finance",
        "sub_domain": "Reporting",
        "region": "South LATAM",
        "country": "Developed Europe",
        "last_updated": "2025-04-11",
        "status": "Success"
    }
]

export const UserTable = ({
  resetFilters,
    filters,
    selectedDomainItems,
    selectedRows,
    setSelectedRows,
  }) => {
    const toast = useToast();
    const menu = useRef(null);
  
    // State to track selected row data and popup visibility
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [enableChangeMemberRolePopUp, setEnableChangeMemberRolePopUp] = useState(null);
  
    // Fetch all user data using a query
    const {
      data: allUserData = [],
      isLoading: isAllUserDataLoading,
      isFetching: isAllUserDataFetching,
    } = useQuery({
      queryKey: ["getAllUserList"],
      queryFn: () => accessManagementService.getAllUser(),
    });
  
    // Filtering user data based on selected domain/sub-domain
    const filteredUserData = useMemo(() => {
      if (Object.keys(selectedDomainItems).some((row) => row.endsWith(":SD"))) {
        return dummyData.filter((item) =>
          Object.keys(selectedDomainItems)
            .map((row) => row.split(":")[0])
            .includes(item.sub_domain)
        );
      }
      return dummyData;
    }, [dummyData, selectedDomainItems]);
  
    // Mutation function for deleting a user
    const { mutate: deleteUser, isPending: isDeleting } = ChangeUserRoleMutation(
      () => {
        toast({ severity: "info", summary: "Confirmed", detail: "User Deleted Successfully.", life: 3000 });
        resetFilters()
      },
      (error) => {
        toast({ severity: "info", summary: "Error", detail: error.response.data.detail, life: 3000 });
      }
    );
  
    // Function to confirm and remove a user
    const acceptRemoveMember = (user) => {
      deleteUser([{ ...user, end_date: Date.now(), last_modified_by: localStorage.getItem("userId") }]);
    };
  


 
    const getTableColumn = () => {
      return [
        { header: "#", body: (data, options) => options.rowIndex + 1 },
        // { 
        //   filterField: "user_name",
        //   header: "Asset Name",
        //   sortable: true,
        //   sortField: "user_name",
        //   body: (rowData) => <span>{rowData.user_name}</span>,
        //   filter: true,
        //   showFilterMenu: false,
        //   filterElement: (options) => multiSelectFilter(options, "user_name", filteredUserData),
        // },
        // { 
        //   filterField: "user_email",
        //   header: "Email",
        //   sortable: true,
        //   sortField: "user_email",
        //   body: (rowData) => <span>{rowData.user_email}</span>,
        //   filter: true,
        //   showFilterMenu: false,
        //   filterElement: (options) => multiSelectFilter(options, "user_email", filteredUserData),
        // },
         { field: "asset_name", header: "Asset Name", sortable: true },
        { field: "domain", header: "Domain", sortable: true },
        { field: "sub_domain", header: "Subdomain", sortable: true },
         { 
          filterField: "region",
          header: "Cluster",
          sortable: true,
          sortField: "region",
          body: (rowData) => <span>{rowData.region}</span>,
          filter: true,
          showFilterMenu: false,
          filterElement: (options) => multiSelectFilter(options, "region", filteredUserData),
        },
         { 
          filterField: "country",
          header: "Country",
          sortable: true,
          sortField: "country",
          body: (rowData) => <span>{rowData.country}</span>,
          filter: true,
          showFilterMenu: false,
          filterElement: (options) => multiSelectFilter(options, "country", filteredUserData),
        },
     
         { field: "last_updated", header: "Last Updated", sortable: true },
          { field: "status", header: "Status", sortable: true },
        // {
        //   field: "action",
        //   header: "Action",
        //   body: (rowData) => (
        //     <>
        //       <Button
        //         size="small"
        //         text
        //         style={{ padding: 0 }}
        //         icon="pi pi-ellipsis-v"
        //         onClick={(e) => {
        //           menu.current.toggle(e);
        //           setSelectedRowData(rowData);
        //         }}
        //         aria-haspopup
        //         aria-controls="popup_menu"
        //       />
        //       <Menu
        //         model={[
        //           {
        //             label: "Remove",
        //             icon: "pi pi-fw pi-times",
        //             command: () =>
        //               confirmDialog({
        //                 message: `Are you sure you want to remove user ${selectedRowData.user_name}?`,
        //                 header: "Confirmation",
        //                 icon: "pi pi-exclamation-triangle",
        //                 defaultFocus: "acceptRemoveMember",
        //                 accept: () => acceptRemoveMember(selectedRowData),
        //               }),
        //           },
        //           {
        //             label: "Change Role",
        //             icon: "pi pi-fw pi-check",
        //             command: () => setEnableChangeMemberRolePopUp(selectedRowData),
        //           },
        //         ]}
        //         popup
        //         ref={menu}
        //       />
        //     </>
        //   ),
        // },
      ];
    };
  
     useEffect(() => {
        resetFilters(); // Calls the reset function on load
      }, []);
    

    return (
      <>
        {/* Change Member Role Popup */}
        {enableChangeMemberRolePopUp && (
          <ChangeMemberRoleDialog resetFilters={resetFilters} userIds={[enableChangeMemberRolePopUp]} onHide={() => setEnableChangeMemberRolePopUp(null)} />
        )}
  
        {/* Table Component */}
        <TableComponent
          filters={filters}
          filterDisplay="row"
          globalFilterFields={["user_name", "user_email"]}
          style={{ height: "45vh", maxHeight: "45vh", minHeight: "45vh" }}
          scrollHeight="45vh"
          loading={false}
          removableSort
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
        
          checked
          paginator
          rows={10}
          totalRecords={filteredUserData.length}
          rowsPerPageOptions={[5, 10, 30, 50, 100]}
          tableData={filteredUserData}
          columns={getTableColumn()}
        />
      </>
    );
  };
  



 

  